import debug from 'debug';
import Utils from 'Global/Shared/Components/Utils/Utils';
import CloudApi from './CloudApi'

const log = debug('CloudApi:Search');
const utils = new Utils();

/**
 * @deprecated use api-management instead, and create missing functionality
 */
class Search extends CloudApi {

	/**
	 * Obsolete: Use productsByCategories() instead
	 * @param {Object} options 
	 * @param {string} options.categories Pipe separated: The categories which the returned adverts must have at least one of. Left empty will disregard categories of the returned adverts
	 * @param {string} [options.catalogCategoriesToExclude] Pipe separated: The categories which the returned adverts must not have any of. Left empty will disregard categories of the returned adverts
	 * @param {number} [options.numberOfResults]
 	 * @param {string} [options.search]
	 * @param {string} [options.sort] The name of the field to sort the response by. If omitted, will sort by the default "best match"
	 * @param {number} [options.startPage] Shows first page if no page is selected
	 * @param {string} [options.tradeLabels] Pipe separated: The tradeLabels which the returned adverts must have. Left empty will disregard tradeLabels of the returned adverts
	 * @param {string} [options.zipCode]
	 */
	AdvertsByCategories(options) {
		let url = `//${this.settings.cloudApiUrl}/Search/products/?categories=${options.categories}`;

		if (!utils.IsNullOrWhiteSpace(options.catalogCategoriesToExclude)) url += `&categories=${options.catalogCategoriesToExclude}`;
		if (!utils.IsNullOrWhiteSpace(options.numberOfResults)) url += `&numberOfResults=${options.numberOfResults}`;
		if (!utils.IsNullOrWhiteSpace(options.search)) url += `&search=${options.search}`;
		if (!utils.IsNullOrWhiteSpace(options.sort)) url += `&sort=${options.sort}`;
		
		if (!utils.IsNullOrWhiteSpace(options.startPage)) {
			url += `&startPage=${options.numberOfResults}`;
		} else {
			url += `&startPage=1`;
		}

		if (!utils.IsNullOrWhiteSpace(options.tradeLabels)) url += `&tradeLabels=${options.tradeLabels}`;
		if (!utils.IsNullOrWhiteSpace(options.zipCode)) url += `&zipCode=${options.zipCode}`;

		return this.Get(url);
	}

	/**
	 * Obsolete: Use productsForCustomer() instead
	 * @param {string} customerId 
	 * @param {number} numberOfResults 
	 * @param {number} [startPage] Default 1
	 * @param {boolean} [isFeed] Default false
	 */
	AdvertsForCustomer(customerId, numberOfResults, startPage, isFeed) {
		let url = '';
		if (isFeed !== undefined) {
			url = `//${this.settings.cloudApiUrl}/Search/productsforcustomer/${customerId}?numberOfResults=${numberOfResults}&startPage=${startPage !== undefined ? startPage : 1}&isFeed=${isFeed}`;
		}
		else {
			url = `//${this.settings.cloudApiUrl}/Search/productsforcustomer/${customerId}?numberOfResults=${numberOfResults}&startPage=${startPage !== undefined ? startPage : 1}`;
		}
		return this.Get(url);
	}

	/**
	 * @param {Object} options 
	 * @param {string} options.customerIds
	 * @param {string} [options.categories] Pipe separated: The categories which the returned adverts must have at least one of. Left empty will disregard categories of the returned adverts
	 * @param {boolean} [options.isFeed] Denotes whether to fetch adverts that are from feed, or not from feed. If parameter isn't set, both are fetched
	 * @param {number} [options.numberOfResults]
 	 * @param {string} [options.search]
	 * @param {string} [options.sort] The name of the field to sort the response by. If omitted, will sort by the default "best match"
	 * @param {number} [options.startPage] Shows first page if no page is selected
	 * @param {string} [options.tradeLabels] Pipe separated: The tradeLabels which the returned adverts must have. Left empty will disregard tradeLabels of the returned adverts
	 * @param {string} [options.zipCode]
	 */
	AdvertsForCustomers(options) {
		let url = `//${this.settings.cloudApiUrl}/Search/productsforcustomers?customerIds=${options.customerIds}`;

		if (!utils.IsNullOrWhiteSpace(options.categories)) url += `&categories=${options.categories}`;
		if (!utils.IsNullOrWhiteSpace(options.isFeed)) url += `&isFeed=${options.isFeed}`;
		if (!utils.IsNullOrWhiteSpace(options.numberOfResults)) url += `&numberOfResults=${options.numberOfResults}`;
		if (!utils.IsNullOrWhiteSpace(options.search)) url += `&search=${options.search}`;
		if (!utils.IsNullOrWhiteSpace(options.sort)) url += `&sort=${options.sort}`;
		
		if (!utils.IsNullOrWhiteSpace(options.startPage)) {
			url += `&startPage=${options.numberOfResults}`;
		} else {
			url += `&startPage=1`;
		}

		if (!utils.IsNullOrWhiteSpace(options.tradeLabels)) url += `&tradeLabels=${options.tradeLabels}`;
		if (!utils.IsNullOrWhiteSpace(options.zipCode)) url += `&zipCode=${options.zipCode}`;

		return this.Get(url);
	}

	/**
	 * Obsolete: Use productsFromSearchWord() instead
	 * @param {Object} facets
	 */
	AdvertsFromSearchWord(facets) {
		let url = `//${this.settings.cloudApiUrl}/Search?${facets}`;
		return this.Get(url);
	}

	/**
	 * @param {string} query 
	 */
	AutoSuggest(query) {
		let url = `//${this.settings.cloudApiUrl}/AutoSuggest?searchTerm=${query}`;
		return this.Get(url);
	}

	/**
	 * @param {Object} facets
	 * 
	 * @returns {Promise} products dataset
	 */
	 productsByCategories(facets) {
		let url = `//${this.settings.cloudApiUrl}/Search/products?${facets}`;
		return this.Get(url);
	}

	/**
	 * @param {Object} options
	 * @param {string} options.customerId
	 * @param {Object} options.facets
	 * @param {boolean} [options.isFeed] Default undefined = both catalog and feed products
	 * 
	 * @returns {Promise} products dataset
	 */
	productsForCustomer({ customerId, facets, isFeed }) {
		let url = `//${this.settings.cloudApiUrl}/Search/productsforcustomer/${customerId}?${facets}`;

		if (isFeed !== undefined) url = url + `&isFeed=${isFeed}`;

		return this.Get(url);
	}

	/**
	 * @param {Object} facets
	 * 
	 * @returns {Promise} products dataset
	 */
	productsFromSearchWord(facets) {
		let url = `//${this.settings.cloudApiUrl}/Search?${facets}`;
		return this.Get(url);
	}
}

export default Search;
